/* eslint-disable camelcase */
import React from 'react';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import ErrorTwoToneIcon from '@mui/icons-material/ErrorTwoTone';
import { useApp } from '../../hooks/use-app';

const StyledDiv = styled('div')(() => ({
  display: 'flex',
  '&.orangeText': {
    color: '#FF9500',
  },
  '&.redText': {
    color: '#FF3B30',
  },
  '& .icon': {
    marginLeft: '5px',
    width: '21px',
    marginTop: '-2px',
  },
}));

export type DeviceVersionStatus = 'ok' | 'outdated' | 'unsupported' | 'unrecognized';

interface DeviceInfo {
  value: {
    app_version: string;
    platform: string;
    version_status: DeviceVersionStatus;
  } | null | undefined;
}

const AppVersionCell = ({ value }: DeviceInfo) => {
  const app = useApp();

  if (!value) return null;

  const { version_status: versionStatus, app_version: appVersion } = value;

  let tooltipText = '';
  let textClassName = '';
  const {
    mobile_version_support: {
      months_till_unsupported: monthsTillUnsupported,
    },
  } = app.globals.config;

  switch (versionStatus) {
    case 'outdated':
      textClassName = 'orangeText';
      tooltipText = 'Nearing end of Fulcrum support. Update required soon.';
      break;

    case 'unsupported':
      textClassName = 'redText';
      tooltipText = `Outdated mobile app versions (+${monthsTillUnsupported} months) are not supported. Update required.`;
      break;

    case 'unrecognized':
      textClassName = 'redText';
      tooltipText = 'Unrecognized mobile app version. Update required.';
      break;

    case 'ok':
      break;
    default:
      break;
  }

  return (
    <StyledDiv className={textClassName}>
      {appVersion}
      {appVersion && textClassName && tooltipText && (
        <Tooltip title={tooltipText} arrow placement="top">
          <ErrorTwoToneIcon className="icon" />
        </Tooltip>
      )}
    </StyledDiv>
  );
};

export default AppVersionCell;
